import React from 'react';
import AppLayout from '../../components/AppLayout';
import {LoadGraphic,Step,PageMenu} from '../../components/Common';
import {Input,Button,Area,EditableDate, PageSelector} from '../../components/Input';
import u from '../../utilities/Utilities';
import '../../styles/inventory/inventory-component.scss';
import moment from 'moment';


export default class InventoryPage extends React.Component{

    id = this.props.match.params.id;

    settings={
        /**** Page Setup ****/
        title:"Inventory",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/inventory",
        label:"inventory",
    }

    pageMenuButtons=[

    ];

    state={
        pageMenuButtons:[],
        pageComponents:{},
        content:{},
    }

    componentDidMount=()=>{

    }

    render=()=>{
        const {pageMenuButtons,pageComponents,content}=this.state;
        return (
            <AppLayout settings={this.settings}>
                <div className="page-error">{this.state.error}</div>

                <PageMenu buttons={pageMenuButtons}
                          settings={this.settings}
                          components={pageComponents}
                          />
                <div className='inventory-page'>
                    {
                        (content.attachedType)
                            ?
                            <h3 className='inventory-title'>({content.attachedType}) {content.attachedLabel}</h3>
                            :
                            null
                    }
                    <div className='inventory-view'>
                        <InventoryComponent inventoryID={this.id}
                                            onContent={(content)=>{this.setState({content:content})}}
                                            />
                    </div>
                </div>
            </AppLayout>
        )
    }
}


export class InventoryComponent extends React.Component{

    pageLength=10;

    state={
        step:"view",
        content:{
            items:[],
        },
        loading:false,
        loadText:"",
        startIndex:0,
        endIndex:this.pageLength,
        page:1,
    }

    componentDidMount=()=>{
        const permissions=u.getPermissions("inventory");
        this.setState({permissions:permissions});
        if(permissions.view==2){
            this.getInventoryContent();
        }
    }

    getInventoryContent=async ()=>{
        this.setState({loading:true,loadText:"Loading..."});
        try{
            const response=await u.postAsync({
                url:"/api/get-inventory",
                data:{
                    testDelay:2000,
                    inventoryID:this.props.inventoryID
                }
            });
            this.setState({content:response.data,loading:false});
            if(this.props.onContent){
                this.props.onContent(response.data);
            }
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onChange=(value,label,index)=>{
        let {content}=this.state;
        content.items[index][label]=value;
        this.setState({content:content});
    }

    onDownload=({filename,filestamp})=>{
        this.downloading=true;
        u.download(filename,filestamp,()=>{
            this.downloading=false;
        },(error)=>{
            this.downloading=false;
            this.setState({error:error});
        });
    }

    onChangePage=(newPage)=>{
        const startIndex=this.pageLength * (newPage-1);
        const endIndex=startIndex + this.pageLength;
        this.setState({
            page:newPage,
            startIndex:startIndex,
            endIndex:endIndex
        });
    }

    render=()=>{
        const {step,content,loading,loadText,permissions,page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(content.items.length/this.pageLength);
        const url="/api/update-inventory-item-info";
        
        return (
            <div className='inventory-component-container'>
                <LoadGraphic active={loading} text={loadText}/>

                <Step active={step=="view"}>
                    {
                        (content.items.length > 0)
                            ?
                            <div className='list-table inventory-table'>
                                <table>
                                    <thead>
                                        <tr>
                                            <th className='remove left'/>
                                            <th className='th-item'>Item</th>
                                            <th className='th-quantity'>Quantity</th>
                                            <th className='th-date'>Return On</th>
                                            <th className='th-date'>Servicing On</th>
                                            <th className='th-date'>Expiry On</th>
                                            <th className='th-download'>Man.</th>
                                            <th className='th-download right'>Lic.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            content.items.map((item,index)=>{
                                                if(index < startIndex || index>=endIndex){
                                                    return null;
                                                }
                                                return (
                                                    <tr key={index}>
                                                        <td>{index+1}.</td>
                                                        <td>({item.itemCode}) {item.itemName}</td>
                                                        <td>{item.quantity} {item.servingQuantifier}</td>
                                                        <td className='th-date'>
                                                            <EditableDate values={{
                                                                              value:item.returnDate,
                                                                              enabled:(permissions.update==2)
                                                                            }}
                                                                            range={[5,5]}
                                                                            label="Return Date"
                                                                            field="returnDate"
                                                                            onChange={this.onChange}
                                                                            id={content.inventoryID}
                                                                            index={index}
                                                                            url={url}
                                                                            />
                                                        </td>
                                                        <td className='th-date'>
                                                            <EditableDate values={{
                                                                            value:item.servicingDate,
                                                                            enabled:(permissions.update==2)
                                                                          }}
                                                                          range={[5,5]}
                                                                          label="Servicing Date"
                                                                          field="servicingDate"
                                                                          onChange={this.onChange}
                                                                          id={content.inventoryID}
                                                                          index={index}
                                                                          rules={{addEmpty:true}}
                                                                          url={url}
                                                                          />
                                                        </td>
                                                        <td className='th-date'>
                                                            <EditableDate values={{
                                                                            value:item.expiryDate,
                                                                            enabled:(permissions.update==2)
                                                                          }}
                                                                          range={[5,5]}
                                                                          label="Expiry Date"
                                                                          field="expiryDate"
                                                                          onChange={this.onChange}
                                                                          rules={{addEmpty:true}}
                                                                          id={content.inventoryID}
                                                                          index={index}
                                                                          url={url}
                                                                          />
                                                        </td>
                                                        <td className='th-download'>
                                                            {
                                                                (item.operatingManual?.filename)
                                                                    ?
                                                                    <img className='inventory-download-icon' 
                                                                        onClick={()=>{this.onDownload(item.operatingManual)}} 
                                                                        title="Operating Manual" 
                                                                        src="/images/input/down-arrow.png"
                                                                        />
                                                                    :
                                                                    "-"
                                                            }
                                                        </td>
                                                        <td className='th-download'>
                                                            {
                                                                (item.licenseFile?.filename)
                                                                    ?
                                                                    <img className='inventory-download-icon' 
                                                                        onClick={()=>{this.onDownload(item.licenseFile)}} 
                                                                        title="License File" 
                                                                        src="/images/input/down-arrow.png"
                                                                        />
                                                                    :
                                                                    "-"
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                
                                <div style={{margin:"20px auto"}}>
                                    <PageSelector maxPage={maxPage}
                                                  page={page}
                                                  onChange={this.onChangePage}
                                                  />
                                </div>
                            </div>
                            :
                            <div className='list-placeholder'>
                                <b>No Items Added</b>
                                <div>Inventory items can only be transferred from store module</div>
                            </div>
                    }
                    
                </Step>
            </div>
        )
    }
}